import { useMutation, useQuery } from "@tanstack/react-query";
import { del, get, post, put } from "./request";

const EMAIL_TEMPLATES = '/api/v1/email_templates';

export function useGetAllEmailTemplateTypes(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['emailTemplateTypes', payload],
        async () => await get(`${EMAIL_TEMPLATES}/get_all_template_types`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return { 
      template_types: items, 
      total: meta.total_count, 
      isFetching, 
      refetch 
    };
    //return { template_types: (data || {}).data, total: ((data || {}).data || {}).count || 0, isFetching, refetch };
}

export function useGetAllTemplates(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['templates', payload],
        async () => await get(`${EMAIL_TEMPLATES}`, payload),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return { 
      templates: items, 
      total: meta.total_count, 
      isFetching, 
      refetch 
    };
    //return { templates: ((data || {}).data || {}).list || [], total: ((data || {}).data || {}).count || 0, isFetching, refetch };
}

export function useCreateEmailTemplate(onSuccess?: any, onError?: any) {
    const { mutate: createEmailTemplate, error, isLoading: creating } = useMutation(
        ['createEmailTemplate'],
        async (payload: any) => await post(`${EMAIL_TEMPLATES}`, payload),
        {
            onError,
            onSuccess: (response) => {
              debugger
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { createEmailTemplate, error, creating };
}

export function useUpdateEmailTemplate(onSuccess?: any, onError?: any) {
    const { mutate: updateEmailTemplate, error, isLoading: updating } = useMutation(
        ['updateEmailTemplate'],
        async (payload: any) => await put(`${EMAIL_TEMPLATES}/${payload.id}`, payload),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { updateEmailTemplate, error, updating };
}

export function useDeleteEmailTemplate(onSuccess?: any, onError?: any) {
    const { mutate: deleteEmailTemplate, error, isLoading: deleting } = useMutation(
        ['deleteEmailTemplate'],
        async (id) => await del(`${EMAIL_TEMPLATES}/${id}`),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { deleteEmailTemplate, error, deleting };
}
